import { brandService } from '../services/brand';

export const APP_NAME = brandService.getName();
export const APP_ID = 'mednnectai';
export const EXPORT_FORMAT_TYPE = 'mednnectai.providers';
export const EXPORT_PASSWORD = 'mednnectai-APP';